export interface BrowserCache<Data> {
    data: Data,
    identifier: string | number,
    timestamp: number
}

export const default_life_time = 300_000;

export function clearExpiredItems<T>(cache: BrowserCache<T>[], lifetime: number = default_life_time) {
    return cache.filter(x=> new Date().getTime() <= x.timestamp + lifetime)
}

export function getCacheItem<T>(cache: BrowserCache<T>[], identifier: string | number) {
    const cachedRecord = cache.filter(x => x.identifier === identifier).pop();

    if (cachedRecord) {
        return cachedRecord.data;
    }

    return undefined;
}

export function addCacheItem<T>(cache: BrowserCache<T>[], identifier: string | number, data: T) {
    cache = cache.filter(x => x.identifier != identifier);
    cache.push({
        identifier: identifier,
        data: data,
        timestamp: new Date().getTime(),
    });

    return cache;
}
